class Calculator {
}
export default Calculator;
//# sourceMappingURL=Calculator.js.map